import {
  API_EMPLOYEE_REVIEW_SUMMARY,
  API_GET_ADMIN_DASHBOARD,
  API_GET_COMPLETE_DATA,
  API_GET_EMPLOYEE_DASHBOARD,
  API_GET_LAST_THREE_PERIOD,
  API_GET_MANAGER_DASHBOARD,
  API_PROJECT,
  API_PROJECT_LEADS,
} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

export const getEmployeeDashboardApi = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_GET_EMPLOYEE_DASHBOARD,
    });
    return res.data;
  } catch (error) {
    console.error('getEmployeeDashboardApi Error:', error.message);
    return null;
  }
};

export const getEmployeeByPeriods = async (periods) => {
  try {
    if (periods === null || periods === undefined) {
      return null;
    }
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_GET_EMPLOYEE_DASHBOARD}/period/${periods}`,
    });
    return res.data;
  } catch (error) {
    console.error('getEmployeeDashboardApi Error:', error.message);
    return null;
  }
};


export const getLastThreePeriods = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_GET_LAST_THREE_PERIOD
    })
    return res.data;
  } catch (error) {
    console.error('getLastThreePeriods Error:', error.message);
    return null;
  }
}

export const getManagerDashboardApi = async (projectId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_GET_MANAGER_DASHBOARD}/${projectId !== null ? projectId : ''}`,
    });
    console.log("response from admin api fetch: ", res)
    return res.data;

  } catch (error) {
    console.error('getManagerDashboardApi Error:', error.message);
    return null;
  }
};

export const getAdminDashboardApi = async (period) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_GET_ADMIN_DASHBOARD}/${period}`,
    });
    return res.data;
  } catch (error) {
    console.error('getAdminDashboardApi Error:', error.message);
    return null;
  }
};

export const getAdminDashboardApiByPeriods = async (period) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_GET_ADMIN_DASHBOARD}/period/${period}`,
    });
    return res.data;
  } catch (error) {
    console.error('getAdminDashboardApi Error:', error.message);
    return null;
  }
};

export const getCompleteDataApi = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_GET_COMPLETE_DATA,
    });
    return res.data;
  } catch (error) {
    console.error('getCompleteDataApi Error:', error.message);
    return null;
  }
};

export const getEmployeeReviewSummary = async (currentPeriodId, projectId, params) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_EMPLOYEE_REVIEW_SUMMARY}/${currentPeriodId}/project/${projectId}`,
      params: params,
    });
    return res;
  } catch (error) {
    console.error('getEmployeeReviewSummary Error:', error.message);
  }
};

export const getProjectApi = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_PROJECT,
    });
    return res.data;
  } catch (error) {
    console.error('getProjectApi Error:', error.message);
    return null;
  }
};

export const getProjectApiLeads = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_PROJECT_LEADS,
    });
    return res.data;
  } catch (error) {
    console.error('Api Project leads data failed to retrieve:', error.message);
    return null;
  }
};

export const getProjectApiLeadsByPeriods = async (periods, projectId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url:  `${API_GET_MANAGER_DASHBOARD}/${projectId}/period/${periods}`,
    });
    return res.data;
  } catch (error) {
      console.error('Api Project leads by periods data failed to retrieve:', error.message, projectId);
    return null;
  }
};
